import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface ConfirmDialogData {
  title: string;
  message: string;
  warningText?: string;
  confirmLabel?: string;
  confirmIcon?: string;
  confirmStyle?: 'danger' | 'primary';
  icon?: string;
  commande?: any;
}

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss']
})
export class ConfirmDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData
  ) {}

  get showWarning(): boolean {
    return !!this.data.warningText;
  }

  get confirmLabel(): string {
    return this.data.confirmLabel ?? 'Confirmer la suppression';
  }

  get confirmIcon(): string {
    return this.data.confirmIcon ?? '🗑️';
  }

  get confirmStyle(): 'danger' | 'primary' {
    return this.data.confirmStyle ?? 'danger';
  }

  get icon(): string {
    return this.data.icon ?? '⚠️';
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }
}
